import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principe";
import principle02 from "./layouts/principle-02/principe";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";

const lesson: Lesson = {
  id: "064d3352-9cdd-4156-b4ab-9e53825f723a",
  publicId: "15",
  name: "Binaural transfer path analysis",
  contentTypes: { audio: true, interactive: true, video: false },
  body: [principle01, principle02, task01, task02],
  difficulty: 2,
};

export default lesson;
